/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useCallback } from 'react';
import { Tabs } from 'antd';
import { connect } from "react-redux";
import { actions } from '../../../../../../../store/reducers/dashboard';
import { actions as authActions } from '../../../../../../../store/reducers/authentication';
import Frame from '../frame-with-subject';
import { MapTypeButtons } from './style';
import { mapTypesButtons } from './helper';
import SubjectsMap from '../../../../../../../components/SubjectsMap';
import ComponentWithFocus from '../../../../../../Analysis/components/component-with-focus';

const MapWidget = ({
  t = (s) => s,
  data: allData = null,
  PmeDashboardGetWithFilters,
  PmeProjectGetWithFilters,
  CaddDashboardGetWithFilters,
  user = null,
  language,
  selectedProject,
  sourceId,
  module = 'pme',
  isProject = false,
}) => {
  const [frameActions, setFrameActions] = useState(null);
  const [activeMapType, setActiveMapType] = useState(mapTypesButtons[0].type);
  const [closed, setClosed] = useState(false);

  const onMapTypeChange = useCallback((data) => {
    if (module === 'cadd') {
      CaddDashboardGetWithFilters(data);
    } else {
      if (!isProject) {
        PmeDashboardGetWithFilters(data);
      } else {
        PmeProjectGetWithFilters(data);
      }
    }
  }, [module, isProject]);

  const actions = useMemo(() => ({
    closed,
    setClosed,
    unFocus: () => { },
  }), [closed]);

  const mapTypes = useMemo(() => (
    <MapTypeButtons>
      <Tabs
        activeKey={activeMapType}
        defaultActiveKey={activeMapType}
        onChange={(val) => setActiveMapType(val)}
        items={mapTypesButtons.map((btn) => ({
          key: btn.type,
          tabKey: btn.type,
          label: t(btn.label),
        }))}
      />
    </MapTypeButtons>
  ), [activeMapType, t]);

  return (
    <ComponentWithFocus
      actions={actions}
    >
      <Frame
        title={t('datastakeMap')}
        onInit={actions => setFrameActions(actions)}
        optionalHeaderContent={mapTypes}
        filtersTitle={t('Dashboard::Scope of Monitoring')}
      >
        <SubjectsMap
          t={t}
          data={allData}
          user={user}
          language={language}
          selectedProject={selectedProject}
          sourceId={sourceId}
          module={module}
          onFiltersChange={onMapTypeChange}
          initialType={mapTypesButtons[0].type}
          frameActions={frameActions}
          activeMapType={activeMapType}
          setActiveMapType={setActiveMapType}
        />
      </Frame>
    </ComponentWithFocus>
  );
}

export default connect(null, { ...actions, ...authActions })(MapWidget);
